import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["question"]

  static values = {
    className: { type: String, default: "hidden" }
  }

  toggle(event) {
    const parentQuestion = event.currentTarget

    if (!parentQuestion.dataset.dependentQuestions) { return }
    const dependentQuestionKeys = parentQuestion.dataset.dependentQuestions.split(",")

    // is the necessary option selected or not?
    const hide = !!parentQuestion.querySelector(`input[id$="${parentQuestion.dataset.checkInput}"]:checked`)

    this.questionTargets.forEach((question) => {
      if (dependentQuestionKeys.includes(question.dataset.dependentKey)) {
        question.classList.toggle(this.classNameValue, hide)
      }
    })
  }
}
